export default __webpack_public_path__ + "static/O0123-c9bfa250e339f97b7fc1b6c952695336.png";